import EventCell from './EventCell';

export default EventCell;
